import { DateTime } from "luxon";

import { sendEvent } from "@readai/common/tracking/Tracker";

export const scheduleEvent = sendEvent<{ platform: string }>(
  "schedule_rss_link_event",
);
export const rescheduleEvent = sendEvent("reschedule_rss_link_event");
export const scheduleEventError = sendEvent("schedule_rss_link_event_error");
export const viewBestTimes = sendEvent("view_best_times");

const _selectDate = sendEvent<{
  date: string;
  kind: "default" | "best";
}>("select_rss_link_date");

export const selectDate = ({
  date,
  kind,
}: {
  date: DateTime;
  kind: "default" | "best";
}) => {
  const dateString = date.toFormat("yyyy-MM-dd");
  _selectDate({ date: dateString, kind });
};
